module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "section-white content-padded"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "用户昵称"
    },
    model: {
      value: (_vm.nickname),
      callback: function($$v) {
        _vm.nickname = $$v
      },
      expression: "nickname"
    }
  }), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 14
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncFansLoading
    },
    on: {
      "click": _vm.syncFans
    }
  }, [_vm._v("同步微信粉丝")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncTagLoading
    },
    on: {
      "click": _vm.syncTags
    }
  }, [_vm._v("同步微信标签")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.createPop),
      callback: function($$v) {
        _vm.createPop = $$v
      },
      expression: "createPop"
    }
  }, [_c('div', {
    staticClass: "tag-pop"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v("标签名称")]), _vm._v(" "), _c('div', {
    staticClass: "pop-input"
  }, [_c('el-input', {
    ref: "tagName",
    attrs: {
      "maxlength": 6
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createTag
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.createPop = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 新建标签")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fans-list-header"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tagname ? _vm.tagname : '全部用户'))]), _vm._v(" "), (_vm.tagname) ? [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.renamePop),
      callback: function($$v) {
        _vm.renamePop = $$v
      },
      expression: "renamePop"
    }
  }, [_c('div', {
    staticClass: "tag-pop"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v("标签名称")]), _vm._v(" "), _c('div', {
    staticClass: "pop-input"
  }, [_c('el-input', {
    attrs: {
      "maxlength": 6
    },
    model: {
      value: (_vm.renameTag),
      callback: function($$v) {
        _vm.renameTag = $$v
      },
      expression: "renameTag"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.renameLoading
    },
    on: {
      "click": _vm.updateTagName
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.renamePop = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('a', {
    attrs: {
      "slot": "reference",
      "href": "#"
    },
    slot: "reference"
  }, [_vm._v("重命名")])]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.removePop),
      callback: function($$v) {
        _vm.removePop = $$v
      },
      expression: "removePop"
    }
  }, [_c('div', {
    staticClass: "tag-pop"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v("删除标签后，该标签下的所有用户将失去该标签属性。是否确定删除？")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.removeLoading
    },
    on: {
      "click": _vm.removeTag
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.removePop = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('a', {
    attrs: {
      "slot": "reference",
      "href": "#"
    },
    slot: "reference"
  }, [_vm._v("删除")])])] : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 12
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "400",
      "trigger": "click"
    },
    model: {
      value: (_vm.tagsPop),
      callback: function($$v) {
        _vm.tagsPop = $$v
      },
      expression: "tagsPop"
    }
  }, [_c('div', {
    staticClass: "tag-pop"
  }, [_c('div', {
    staticClass: "tag-list"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.groupTag),
      callback: function($$v) {
        _vm.groupTag = $$v
      },
      expression: "groupTag"
    }
  }, _vm._l((_vm.tags), function(item) {
    return _c('el-checkbox', {
      key: item.tag_id,
      staticClass: "tag-pop-item",
      attrs: {
        "label": item.tag_id,
        "disabled": _vm.groupTagSame.indexOf(item.tag_id) >= 0 ? true : false
      }
    }, [_vm._v(_vm._s(item.tag_name))])
  }), 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editTag(-1)
      }
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.tagsPop = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference",
      "disabled": _vm.fansOpenids.length > 0 ? false : true
    },
    slot: "reference"
  }, [_vm._v("打标签")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fans-list",
    attrs: {
      "data": _vm.tableData
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "46"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "headimgurl",
      "label": "用户信息",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "fan-avatar",
          attrs: {
            "src": scope.row.headimgurl,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.remark ? scope.row.remark + ' (' + scope.row.nickname + ')' : scope.row.nickname)), _c('br'), _vm._v(" "), _c('el-popover', {
          ref: "tag",
          attrs: {
            "placement": "bottom",
            "width": "400",
            "trigger": "click"
          },
          model: {
            value: (scope.row.tagpop),
            callback: function($$v) {
              _vm.$set(scope.row, "tagpop", $$v)
            },
            expression: "scope.row.tagpop"
          }
        }, [_c('div', {
          staticClass: "tag-pop"
        }, [_c('div', {
          staticClass: "tag-list"
        }, [_c('el-checkbox-group', {
          model: {
            value: (scope.row.tagids),
            callback: function($$v) {
              _vm.$set(scope.row, "tagids", $$v)
            },
            expression: "scope.row.tagids"
          }
        }, _vm._l((_vm.tags), function(item) {
          return _c('el-checkbox', {
            key: item.tag_id,
            staticClass: "tag-pop-item",
            attrs: {
              "label": item.tag_id
            }
          }, [_vm._v(_vm._s(item.tag_name))])
        }), 1)], 1), _vm._v(" "), _c('el-row', {
          attrs: {
            "gutter": 10
          }
        }, [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-button', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editTag(scope.$index)
            }
          }
        }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-button', {
          staticStyle: {
            "width": "100%"
          },
          on: {
            "click": function($event) {
              scope.row.tagpop = false
            }
          }
        }, [_vm._v("取消")])], 1)], 1)], 1)]), _vm._v(" "), (scope.row.tags.length > 0) ? _vm._l((scope.row.tags), function(item) {
          return _c('span', {
            staticClass: "tag-item"
          }, [_vm._v(_vm._s(item.tag_name))])
        }) : [_vm._v("\n              无标签\n            ")], _vm._v(" "), _c('i', {
          directives: [{
            name: "popover",
            rawName: "v-popover:tag",
            arg: "tag"
          }],
          staticClass: "el-icon-caret-bottom tag-pop-handler"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          ref: "remark",
          attrs: {
            "placement": "bottom",
            "width": "300",
            "trigger": "click"
          },
          model: {
            value: (scope.row.remarkpop),
            callback: function($$v) {
              _vm.$set(scope.row, "remarkpop", $$v)
            },
            expression: "scope.row.remarkpop"
          }
        }, [_c('div', {
          staticClass: "tag-pop"
        }, [_c('div', {
          staticClass: "pop-title"
        }, [_vm._v("备注名称")]), _vm._v(" "), _c('div', {
          staticClass: "pop-input"
        }, [_c('el-input', {
          model: {
            value: (_vm.tempRemark),
            callback: function($$v) {
              _vm.tempRemark = $$v
            },
            expression: "tempRemark"
          }
        })], 1), _vm._v(" "), _c('el-row', {
          attrs: {
            "gutter": 10
          }
        }, [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-button', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRemark(scope.$index)
            }
          }
        }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-button', {
          staticStyle: {
            "width": "100%"
          },
          on: {
            "click": function($event) {
              scope.row.remarkpop = false
            }
          }
        }, [_vm._v("取消")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "popover",
            rawName: "v-popover:remark",
            arg: "remark"
          }],
          on: {
            "click": function($event) {
              return _vm.bindRemark(scope.row.remark)
            }
          }
        }, [_vm._v("修改备注")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > _vm.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.total,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "tags section-white"
  }, [_c('div', {
    staticClass: "tags-header",
    class: {
      'current': _vm.tagname === ''
    },
    on: {
      "click": _vm.tagFilter
    }
  }, [_vm._v("全部用户 "), _c('span', {
    staticClass: "tags-num"
  }, [_vm._v("(" + _vm._s(_vm.total_count) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "tags-body"
  }, [_c('ul', {
    staticClass: "tags-list"
  }, _vm._l((_vm.tags), function(item) {
    return _c('li', {
      class: {
        'current': item.tag_name === _vm.tagname
      },
      on: {
        "click": function($event) {
          return _vm.tagFilter(item.tag_id, item.tag_name)
        }
      }
    }, [_vm._v(" " + _vm._s(item.tag_name) + " "), _c('span', {
      staticClass: "tags-num"
    }, [_vm._v("(" + _vm._s(item.total) + ")")])])
  }), 0)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e268b844", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e268b844"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/fans.vue
// module id = 2952
// module chunks = 0